import { Container } from "reactstrap";
// import Flatpickr from "react-flatpickr";
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

import { Loader } from "../../custom/components/Loader";
import { getInitialDataRequest } from "../../api/controller/StoreController";
import { userState } from "../../api/state/AuthState";
import { useRecoilValue, useSetRecoilState } from "recoil";
import SweetAlert from "react-bootstrap-sweetalert";
import { triggerPaymentRequest } from "../../api/controller/MyVesselController";
import {
  requestPermitRequest,
  requestForDocking,
  deleteDataRequest,
} from "../../api/controller/MyVesselController";
import MyVesselsScreen from "./screensHome/myVessels";
import Vessel from "./screensHome/vessel";
import ApplyForPermit from "./screensHome/applyForPermit";
import RequestToDock from "./screensHome/requestToDock";
import Topup from "./screensHome/topup";
import echo from "../../api/core/echo";
import Initial from "./screensHome/initial";
import RequestVesselAccess from "./screensHome/requestVesselAccess";
import AddNewVessel from "./screensHome/addNewVessel";
import ResubmitVessel from "./screensHome/resubmitVessel";
import { vesselVesselTypeState } from "./vessels/state";
import { HARBOR_ACTIONS_TEMP_DISABLED } from "../../config/harborUiFlags";

const Home = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [currentScreen, setCurrentScreen] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("screen") || "initial";
  });
  const [resubmitVessel, setResubmitVessel] = useState(null);
  const [error, setError] = useState({});

  const user = useRecoilValue(userState);

  const [myBalance, setMyBalance] = useState(null);
  const [queue, _setQueue] = useState([]);
  const queueRef = useRef(queue);
  const setQueue = (data) => {
    queueRef.current = data;
    _setQueue(data);
  };
  const [queueIds, setQueueIds] = useState([]);
  const [myVessels, setMyVessels] = useState([]);
  const [otherVessels, setOtherVessels] = useState([]);
  const [selectedOtherVesselList, setSelectedOtherVesselList] = useState([]);

  const [permitTypes, setPermitTypes] = useState([]);
  // Flat wallet-level GST rate, so the price previews match what is charged.
  const [walletTaxRate, setWalletTaxRate] = useState(0);
  const setRecoilVesselTypes = useSetRecoilState(vesselVesselTypeState);
  const [zones, setZones] = useState([]);

  const [selectedVessel, setSelectedVessel] = useState({});
  const [selectedPermitType, setSelectedPermitType] = useState();
  const [selectedZone, setSelectedZone] = useState();
  const [dockingTypes] = useState(["Berthing", "Mooring"]);
  const [selectedDockingType, setSelectedDockingType] = useState();
  const [topupAmount, setTopupAmount] = useState(null);

  const [successDlg, setSuccessDlg] = useState(false);
  const [successDlgText] = useState("");
  const [errorDlg, setErrorDlg] = useState(false);
  const [errorDlgText, setErrorDlgText] = useState("");
  const [sweet_timer, setSweet_timer] = useState(false);

  useEffect(() => {
    // Notifications navigate with history.push, which doesn't remount this
    // component when already on /home — so the ?screen= param has to be
    // re-read on every location change, not just on mount.
    const params = new URLSearchParams(location.search);
    const screen = params.get("screen");
    if (screen) {
      setError({});
      setSelectedVessel({});
      setCurrentScreen(screen);
    }
    // eslint-disable-next-line
  }, [location.search]);

  useEffect(() => {
    async function getData() {
      const response = await getInitialDataRequest();
      if (response.Status === "error") {
        let msg =
          response.Message ||
          response.payload?.Message ||
          response.payload?.message ||
          "Failed to load home data.";
        if (
          response.HttpStatus === 422 &&
          response.Errors &&
          typeof response.Errors === "object"
        ) {
          const firstKey = Object.keys(response.Errors)[0];
          const firstErr = response.Errors[firstKey];
          if (Array.isArray(firstErr) && firstErr[0]) msg = firstErr[0];
        }
        setErrorDlgText(msg);
        setErrorDlg(true);
        setLoading(false);
        return;
      }
      setMyBalance(response.data?.myBalance);
      setMyVessels(response.data?.myVessels);
      setOtherVessels(response.data?.otherVessels);
      setRecoilVesselTypes({
        ovf: false,
        data: (response.data?.metadata?.vesselTypes ?? []).map((item) => ({
          label: item.name,
          value: item.id,
        })),
      });
      setPermitTypes(response.data?.metadata?.permitTypes ?? []);
      setWalletTaxRate(Number(response.data?.metadata?.walletTaxRate ?? 0));
      setZones(response.data?.metadata?.zones ?? []);
      setQueue(response.data?.queue ?? []);
      setLoading(false);
    }
    getData();

    echo.private("GuestQueueRemoval").listen(`.QueueEvents`, (data) => {
      if (queueRef.current.length > 0 && data?.data?.QueueNumber) {
        const newQueue = queueRef.current
          // .filter((item) => item.queue_number !== data.data.QueueNumber)
          .map((item) => ({
            ...item,
            ahead: item.ahead
              ? item.ahead.filter((ahead) => ahead !== data.data.QueueNumber)
              : [],
          }));
        setQueue(newQueue);
      }
    });
    return () => {
      echo.leave("GuestQueueRemoval");
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    echo.private(`UserBalance.${user.id}`).listen(`.BalanceEvents`, (data) => {
      if (data.data) {
        setMyBalance(data.data);
      }
    });
    return () => {
      echo.leave(`UserBalance.${user.id}`);
    };
  }, [user.id]);

  useEffect(() => {
    const newIDs = queue.map((item) => item.id).sort((a, b) => a - b);
    if (newIDs !== queueIds) {
      setQueueIds(queue.map((item) => item.id).sort((a, b) => a - b));
    }
    // eslint-disable-next-line    
  }, [queue]);

  useEffect(() => {
    queue.forEach((item) => {
      echo
        .private(`GuestQueueUpdate.${item.id}`)
        .listen(`.QueueEvents`, (data) => {
          if (data.type === "Updated") {
            const newQueue = queueRef.current.map((queueItem) =>
              queueItem.id === data.data.id ? data.data : queueItem
            );
            setQueue(newQueue);
            if(data.data.status === "COMPLETED"){
              setSweet_timer(true);
            } else {
              setSweet_timer(true);
            }
          }
        });
    });
    return () => {
      queue.forEach((item) => {
        echo.leave(`GuestQueueUpdate.${item.id}`);
      });
    };
    // eslint-disable-next-line
  }, [queueIds]);

  useEffect(() => {
    console.log(myVessels);
    console.log("selected vessel", selectedVessel);
  }, [myVessels, selectedVessel]);

  const refreshMyVessels = async () => {
    const response = await getInitialDataRequest();
    if (response.Status !== "error" && response.data?.myVessels) {
      setMyVessels(response.data.myVessels);
    }
  };

  const goToMyVessels = () => {
    setError({});
    setCurrentScreen("myVessels");
    setSelectedVessel({});
  };

  const goToRequestVesselAccess = () => {
    setError({});
    setCurrentScreen("requestVesselAccess");
  };

  const goToOtherVessels = (u) => {
    setError({});
    setCurrentScreen("otherVessels");
    setSelectedVessel({});
    setSelectedOtherVesselList(u.vessels);
  };

  const goToTopup = () => {
    if (HARBOR_ACTIONS_TEMP_DISABLED) return;
    setError({});
    setTopupAmount(null);
    setCurrentScreen("topup");
  };

  const goToVesselDetails = ({ vessel }) => {
    setError({});
    setCurrentScreen("vessel");
    setSelectedVessel(vessel);
  };

  const goToApplyForPermit = () => {
    if (HARBOR_ACTIONS_TEMP_DISABLED) return;
    setError({});
    setSelectedPermitType(1);
    setCurrentScreen("applyForPermit");
  };

  const handleUpdateVessel = ({ vesselId, tf }) => {
    const tempMyVessels = myVessels.map((item) => {
      if (item.id === vesselId) {
        return { ...item, active: tf };
      } else {
        return item;
      }
    });
    setSelectedVessel({ ...selectedVessel, active: tf });
    setMyVessels(tempMyVessels);
  };

  const goToRequestToDock = () => {
    if (HARBOR_ACTIONS_TEMP_DISABLED) return;
    setError({});
    setSelectedZone(1);
    setSelectedDockingType("Berthing");
    setCurrentScreen("requestToDock");
  };

  const handleApplyForPermit = async ({ activationDate, paymentMethod }) => {
    setLoading(true);
    setError({});
    const response = await requestPermitRequest({
      Vessel: selectedVessel.id,
      PermitType: selectedPermitType,
      ActivationDate: activationDate,
      PaymentMethod: paymentMethod,
    });
    if (response.Status === "error") {
      setError({ Message: response.Message });
    } else if (response?.Data?.gateway_url) {
      setLoading(false);
      window.location.replace(response.Data.gateway_url);
      return;
    } else {
      setSuccessDlg(true);
      goToMyVessels();
      window.location.reload();
    }
    setLoading(false);
  };

  const handleTopup = async () => {
    setError({});
    setLoading(true);
    const response = await triggerPaymentRequest({
      Amount: topupAmount,
    });
    if (response.Status === "error") {
      setError({ Message: response.Message });
      setLoading(false);
    } else if (response.Data?.gateway_url) {
      window.location.replace(response.Data.gateway_url);
    } else {
      setError({ Message: 'Payment gateway did not return a redirect URL. Please try again.' });
      setLoading(false);
    }
    setTopupAmount(null);
  };

  const handleDeleteVessel = async (vessel) => {
    setLoading(true);
    setError({});
    const response = await deleteDataRequest({ id: vessel.id });
    if (response.Status === "error") {
      setErrorDlgText(response.Message);
      setErrorDlg(true);
    } else {
      setSuccessDlg(true);
      await refreshMyVessels();
    }
    setLoading(false);
  };

  const handleRequestToDock = async () => {
    setLoading(true);
    setError({});
    const response = await requestForDocking({
      Vessel: selectedVessel.id,
      Type: selectedDockingType,
      Zone: selectedZone,
    });
    if (response.Status === "error") {
      setError({ Message: response.Message });
    } else {
      setSuccessDlg(true);
      window.location.reload();
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container>
          <Loader loading={loading} transparent />

          {currentScreen === "initial" && (
            <Initial
              goToMyVessels={goToMyVessels}
              goToOtherVessels={goToOtherVessels}
              goToRequestVesselAccess={goToRequestVesselAccess}
              queue={queue}
              myVessels={myVessels}
              otherVessels={otherVessels}
              zones = {zones}
            />
          )}
          {(currentScreen === "myVessels" ||
            currentScreen === "otherVessels") && (
            <MyVesselsScreen
              user={user}
              setCurrentScreen={setCurrentScreen}
              goToTopup={goToTopup}
              goToVesselDetails={goToVesselDetails}
              myBalance={myBalance}
              vessels={
                currentScreen === "myVessels"
                  ? myVessels
                  : selectedOtherVesselList
              }
              isMyVessel={currentScreen === "myVessels"}
              setResubmitVessel={setResubmitVessel}
              handleDeleteVessel={handleDeleteVessel}
            />
          )}

          {currentScreen === "requestVesselAccess" && (
            <RequestVesselAccess setCurrentScreen={setCurrentScreen} />
          )}

          {currentScreen === "vessel" && (
            <Vessel
              goToApplyForPermit={goToApplyForPermit}
              setCurrentScreen={setCurrentScreen}
              goToMyVessels={goToMyVessels}
              goToRequestToDock={goToRequestToDock}
              handleUpdateVessel={handleUpdateVessel}
              // setMyVessels={setMyVessels}
              // handleCancelPendingPermit={handleCancelPendingPermit}
              selectedVessel={selectedVessel}
            />
          )}

          {currentScreen === "addNewVessel" && (
            <AddNewVessel
              setCurrentScreen={setCurrentScreen}
              refreshMyVessels={refreshMyVessels}
              setResubmitVessel={setResubmitVessel}
            />
          )}

          {currentScreen === "resubmitVessel" && (
            <ResubmitVessel
              vessel={resubmitVessel}
              setCurrentScreen={setCurrentScreen}
              refreshMyVessels={refreshMyVessels}
            />
          )}

          {currentScreen === "applyForPermit" && (
            <ApplyForPermit
              error={error}
              goToVesselDetails={goToVesselDetails}
              permitTypes={permitTypes}
              selectedPermitType={selectedPermitType}
              selectedVessel={selectedVessel}
              setSelectedPermitType={setSelectedPermitType}
              handleApplyForPermit={handleApplyForPermit}
              myBalance={myBalance}
              walletTaxRate={walletTaxRate}
            />
          )}

          {currentScreen === "requestToDock" && (
            <RequestToDock
              error={error}
              goToVesselDetails={goToVesselDetails}
              handleRequestToDock={handleRequestToDock}
              selectedVessel={selectedVessel}
              selectedZone={selectedZone}
              setSelectedZone={setSelectedZone}
              zones={zones}
              dockingTypes={dockingTypes}
              selectedDockingType={selectedDockingType}
              setSelectedDockingType={setSelectedDockingType}
            />
          )}

          {currentScreen === "topup" && (
            <Topup
              error={error}
              goToMyVessels={goToMyVessels}
              handleTopup={handleTopup}
              setTopupAmount={setTopupAmount}
              topupAmount={topupAmount}
              walletTaxRate={walletTaxRate}
            />
          )}
        </Container>
      </div>
      {successDlg ? (
        <SweetAlert
          success
          title={"Success!"}
          confirmBtnText={"Close"}
          onConfirm={() => {
            setSuccessDlg(false);
          }}
        >
          <span>{successDlgText}</span>
        </SweetAlert>
      ) : null}
      {errorDlg ? (
        <SweetAlert
          error
          title={"Error!"}
          confirmBtnText={"Close"}
          onConfirm={() => {
            setErrorDlg(false);
          }}
        >
          {errorDlgText}
        </SweetAlert>
      ) : null}
      {sweet_timer ? (
        <SweetAlert
          title="Request has been Updated!"
          timeout={3000}
          showConfirm={false}
          onConfirm={() => {
            setSweet_timer(false);
          }}
        >
          Please check Queue status.
        </SweetAlert>
      ) : null}
    </React.Fragment>
  );
};

export default Home;
